<div
  class="irembogov-formly-field-block-item text-wrap"
  [id]="block.key"
  *ngFor="
    let block of field.fieldGroup;
    let blockIndex = index;
    let last = last
  ">
  <irembogov-hidden-hide-fields-placeholder
    *ngIf="
      !reviewModeEnabled &&
      field?.options?.formState?.showHiddenAndHideFieldControls
    "
    descriptionName="Block"
    [field]="block"></irembogov-hidden-hide-fields-placeholder>
  <formly-field [field]="block"></formly-field>
</div>
